import { InjectionToken } from '@angular/core';

export const API_URI = new InjectionToken<string>('API_URI');
export const CONNECT_API_URI = new InjectionToken<string>('CONNECT_API_URI');
